import { Http } from "@/plugins/http.js";
import { Doctor } from "@/modules/doctors/Doctor.js";

class Repository {
  #http = Http;
  #cache = new Map();

  constructor() {}

  /**
   * @param {number} doctorId
   * @return Promise<any>
   */
  async getById(doctorId, plain = false) {
    if (this.#cache.has(doctorId)) {
      return this.#cache.get(doctorId);
    }

    const { data } = await this.#http.get(`v1/doctors/${doctorId}`);
    const doctorRaw = data.data;
    const doctor = plain
      ? doctorRaw
      : new Doctor({
          id: doctorRaw.id,
          avatar: doctorRaw.avatar,
          phone: doctorRaw.phone,
          email: doctorRaw.email || "",
          login: doctorRaw.login,
          nickname: doctorRaw.nickname,
          lastName: doctorRaw.last_name,
          firstName: doctorRaw.first_name,
          middleName: doctorRaw.middle_name,
          fullAddress: doctorRaw.full_address,
          address: doctorRaw.address,
          passportNumber: doctorRaw.passportNumber ? Number(doctorRaw.passportNumber) : 0,
          passportSeries: doctorRaw.passportSeries ? Number(doctorRaw.passportSeries) : 0,
          sex: doctorRaw.sex ? Number(doctorRaw.sex) : 0,
          licenseDate: doctorRaw.license_date,
          licenseNumber: doctorRaw.license_number,
          workSettings: doctorRaw.workSettings,
          cityCode: doctorRaw.city_code,
          streetCode: doctorRaw.street_code,
          scientificDegree: doctorRaw.scientific_degree ? Number(doctorRaw.scientific_degree) : 0,
          education: doctorRaw.education ? Number(doctorRaw.education) : 0,
          rating: doctorRaw.rating ? Number(doctorRaw.rating) : 0,
          reviewsCount: doctorRaw.reviewsCount ? Number(doctorRaw.reviewsCount) : 0,
          preferredLanguage: doctorRaw.preferred_language,
          country: doctorRaw.country,
          acquainted: doctorRaw.acquainted ? Number(doctorRaw.acquainted) : 0,
          schedule: doctorRaw.schedule,
          specializations: doctorRaw.specializations,
        });
    this.#cache.set(doctorId, doctor);

    return doctor;
  }
  updateById(doctorId, doctorData) {
    this.#cache.set(doctorId, doctorData);
  }
  /**
   * @param {Partial<DoctorCommon.ApiListFilter>} filter
   * @return Promise<Doctor[]>
   */
  async getAll(filter = {}) {
    try {
      const { data } = await this.#http.get(`v1/doctors`, {
        params: {
          ...filter,
        },
      });

      const items = data.data.map(
        item =>
          new Doctor({
            id: item.user_id,
            avatar: item.avatar,
            phone: item.user_phone,
            email: item.email,
            login: item.user_login,
            nickname: item.user_nickname,
            lastName: item.user_last_name,
            firstName: item.user_first_name,
            middleName: item.user_middle_name,
            fullAddress: item.user_full_address,
            address: item.user_address,
            passportNumber: item.passport_number,
            passportSeries: item.passport_series,
            sex: item.user_sex,
            licenseDate: item.user_license_date,
            licenseNumber: item.user_license_number,
            workSettings: item.work_settings,
            cityCode: item.user_city_code,
            streetCode: item.user_street_code,
            scientificDegree: item.user_scientific_degree,
            education: item.user_education,
            rating: item.user_rating,
            reviewsCount: item.user_reviews_count,
            preferredLanguage: item.user_preferred_language,
            country: item.user_country,
            acquainted: item.user_acquainted,
            schedule: item.schedule,
            specializations: item.specializations,
          }),
      );

      return items;
    } catch (err) {
      return [];
    }
  }
}

const DoctorsRepository = new Repository();

export { DoctorsRepository };
